<dashboardnav>

  <cradua-party
  [parties]="partys$ | async"
  (party)="onSubmitParty($event)"
  (deletePartyEvent)="onDeleteParty($event)"
  *ngIf="(isLoading$ | async ) === false"
  >
</cradua-party>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoading$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
